/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import {
    CmsPageContentType,
    CmsRouterContentIdentifier,
    ExternalHardwareType,
    HardwareClass,
    HardwareOptionType,
    OwnHardwareType,
    ReduxStateType
} from '@/types/fitting-hardware';
import {currencyParts, formatPrice, interpolate} from '@/utils';
import {getCmsContent} from "@/redux/fitting-hardware";
import {connect} from "react-redux";

export interface StateProps {
    cmsContent: CmsPageContentType
}

export interface HardwareTileProps {
    hardwareOption: HardwareOptionType
    activationFeeText: string
    checked?: boolean
    onClick?: VoidFunction
    selectedHardwareOption?: HardwareOptionType
}

const HardwareTile = ({
                          hardwareOption,
                          activationFeeText,
                          checked = false,
                          onClick,
                          cmsContent,
                          selectedHardwareOption
                      }: StateProps & HardwareTileProps) => {
    const {charges, hardwareClass} = hardwareOption;
    const {name, description, imageUrl, detailDescription} = hardwareOption.cmsContent;
    const [euros, cents] = charges ? currencyParts(charges.recurringCosts) : [undefined, undefined];
    const formattedFee = charges && formatPrice(charges.nonRecurringCosts);

    const routerNextPrice:string[]|undefined = charges?.nextPriceCharges.filter(charges=>charges.startingMonth>1)
        .map(value =>interpolate(cmsContent[CmsRouterContentIdentifier.RouterPriceInfo],
            {startMonth:value.startingMonth
                ,value:value.recurringCosts}));

    const hardwareText = () => {
        switch (hardwareOption.hardwareClass) {
            case HardwareClass.O:
                return CmsRouterContentIdentifier.OntClassInfo;
            case HardwareClass.R:
                return CmsRouterContentIdentifier.RouterClassInfo;
            case HardwareClass.OR:
                return CmsRouterContentIdentifier.CombiRouterClassInfo;
            default:
                return CmsRouterContentIdentifier.RouterClassInfo;
        }
    }

    function disableSelectionButton(selectedHardwareOption: OwnHardwareType | ExternalHardwareType | undefined, hardwareOption: OwnHardwareType | ExternalHardwareType, checked: boolean | undefined) {
        if (selectedHardwareOption === undefined) {
            return false;
        }
        if(selectedHardwareOption.hardwareClass === HardwareClass.OR && (hardwareOption.hardwareClass === HardwareClass.O || hardwareOption.hardwareClass === HardwareClass.R)){
            return true;
        }

        if(selectedHardwareOption.hardwareClass === HardwareClass.R && (hardwareOption.hardwareClass === HardwareClass.OR)){
            return true;
        }

        if(selectedHardwareOption.hardwareClass === HardwareClass.O && (hardwareOption.hardwareClass === HardwareClass.OR)){
            return true;
        }

        if(selectedHardwareOption.hardwareClass === HardwareClass.R && (hardwareOption.hardwareClass === HardwareClass.R && !checked)){
            return true;
        }

        if(selectedHardwareOption.hardwareClass === HardwareClass.R && hardwareOption.hardwareClass === HardwareClass.O ){
            return false
        }

        if(selectedHardwareOption.hardwareClass === HardwareClass.O && (hardwareOption.hardwareClass === HardwareClass.R ||
            (hardwareOption.hardwareClass === HardwareClass.O && !checked ))){
            return false
        }
        return !checked;
    }

    return (
        <>
            {
                hardwareClass == HardwareClass.OR &&

                <div className="combi-router-hint" >
                    <strong dangerouslySetInnerHTML={{__html: cmsContent[CmsRouterContentIdentifier.CombiRouterHighlightText]}}/>
                </div>
            }
            <div className={checked ? 'hardware-tile-checked' : 'hardware-tile'}>

                <div className="col-sm-5 router-tile-section">
                    <div className="router-image-section">
                        <div style={{padding: '25px', backgroundColor: '#EAECEE',
                            height: '80%', width: '100%'}}>
                            {imageUrl &&
                            <img
                                className="shop-tile-image-product"
                                src={imageUrl.rendered} alt=""/>
                            }
                        </div>
                        <div className="router-icon-text"
                             dangerouslySetInnerHTML={{__html: cmsContent[hardwareText()]}}>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 router-tile-section">
                    <div className="device-name">
                        <strong
                            dangerouslySetInnerHTML={{__html: name.rendered}}/>
                    </div>
                    <div
                        className="router-short-description"
                        dangerouslySetInnerHTML={{__html: description.rendered}}
                    />
                    {detailDescription && (
                        <div className="product-details"
                             dangerouslySetInnerHTML={{ __html: detailDescription?.rendered }}
                        />
                    )
                    }
                </div>
                <div className="col-sm-3 router-tile-section" style={{position: "relative"}}>
                    {charges && (
                        <div className={`price price-left router-price`}>
                            <span className="cond">monatlich</span>
                            <span className="sum">{euros}</span>
                            <span className="suffix">{cents}</span>
                            <span className="currency">€</span>
                            {routerNextPrice? routerNextPrice.map((value) =>
                                <span className="cond"> {value+' €'} </span>):''}
                            <span className="condAfter">
                        + {activationFeeText} {formattedFee}
                    </span>
                        </div>
                    )}
                    <button
                        className={checked ? "btn btn-plain select-Router-button selected-Router-button" : "btn btn-plain select-Router-button"}
                        onClick={onClick}
                        disabled={disableSelectionButton(selectedHardwareOption, hardwareOption, checked)}
                        dangerouslySetInnerHTML={{__html: checked ? 'Entfernen' : 'Auswählen'}}
                    />
                </div>
            </div>
            <br/>
        </>
    );
};

const mapStateToProps = (state: ReduxStateType): StateProps => ({
    cmsContent: getCmsContent(state)
});

export default connect(mapStateToProps)(HardwareTile);